import { render, staticRenderFns } from "./add-notification-model.vue?vue&type=template&id=99aea856&scoped=true&"
import script from "./add-notification-model.vue?vue&type=script&lang=js&"
export * from "./add-notification-model.vue?vue&type=script&lang=js&"
import style0 from "./add-notification-model.vue?vue&type=style&index=0&id=99aea856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99aea856",
  null
  
)

component.options.__file = "add-notification-model.vue"
export default component.exports